import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from '../PageSections/PageSection';
import * as styles from './AuthorCard.module.scss';

export default function AuthorCard({ author, isExpert }) {
  return (
    <PageSection
      slim
      className={styles.authorCard}
      data-analytics-component={'author-card'}
      data-analytics-id={author?.name}
    >
      <div className={styles.authorImage}>
        <div className={styles.authorImg}>
          {author.image && <ContentfulImage className={styles.authorImg} alt={'author'} imageFragment={author.image} />}
          {isExpert && (
            <img
              src="/images/expert-badge-icon.svg"
              alt="Subject matter expert badge"
              loading="lazy"
              className={styles.expertBadgeIcon}
            />
          )}
        </div>
        <div>
          <p className={styles.name}>
            {author?.name} {isExpert && <span>✦ Subject Matter Expert</span>}
          </p>
          <p className={styles.name}>{author?.title}</p>
        </div>
      </div>
      <div
        className={styles.authorBio}
        dangerouslySetInnerHTML={{ __html: author.shortBio?.childMarkdownRemark?.html }}
      />
    </PageSection>
  );
}
